import React from 'react'

type Props = {
  width: string | number
  height: string | number
  fill?: string
}

const IconInfo = ({ width, height, fill = '#09aa5c' }: Props) => {
  return (
    <svg width={width} height={height} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="10" cy="10" r="10" fill={fill} />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.66539 5.79109C8.57565 4.99612 9.19762 4.29999 9.99764 4.29999C10.7973 4.29999 11.4191 4.99545 11.33 5.79008L10.667 11.7035C10.6289 12.0432 10.3417 12.3 9.99991 12.3C9.6583 12.3 9.37118 12.0434 9.33286 11.704L8.66539 5.79109Z"
        fill="#fff"
      />
      <circle cx="9.9998" cy="14.4" r="1.2" fill="#fff" />
    </svg>
  )
}

export default IconInfo
